<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
  }
}
</script>

<style lang="scss">
.gridUser {
  background: #ccc !important;
}

@import './common/scss/common.scss';
@import './common/scss/dataScreen.scss';
@import './common/scss/divGraphic.scss';
// @import './common/scss/theme.scss';

#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.icon {
  width: 18px;
  height: 18px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.marsBlackPanel::before {
  content: "";
  width: calc(100% + 22px);
  height: 39px;
  position: absolute;
  bottom: -39px;
  left: -22px;
  background: url("../static/img/icon/popupLbl.png") 0px 0px no-repeat;
  background-position: 0px 0px;
}

.menu-popover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  color: #000;
  font-size: 26px;
  width: 300px;
  margin: 0;
}

.overview-data-header {
  background: url('./assets/images/icon_header_bg.png')no-repeat;
  background-size: 100% 100%;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
}
</style>



// WEBPACK FOOTER //
// src/App.vue